const config = {
  apiKey: "AIzaSyCP7mhMI3znm1EcKz6mxLh0DqWgBJWJFkM",
  authDomain: "react-pwa-barcode.firebaseapp.com",
  databaseURL: "https://react-pwa-barcode.firebaseio.com",
  projectId: "react-pwa-barcode",
  storageBucket: "react-pwa-barcode.appspot.com",
  messagingSenderId: "165078823083",
  appId: "1:165078823083:web:8304ef3cf53c9052"
};
export default config;
